export default function buildCoalLineConfig (xAxis, data1, data2) {
  return {
    tooltip: {
      trigger: 'axis',
      show: true
    },
    grid: {
      left: '0',
      bottom: '0',
      width: '96%',
      height: '90%',
      containLabel: true
    },
    color: ['#1292c5', '#C58912'],
    xAxis: {
      type: 'category',
      boundaryGap: false,
      axisLabel: {
        color: '#fff'
      },
      data: xAxis
    },
    yAxis: [
      {
        type: 'value',
        splitLine: {
          show: false
        },
        axisLabel: {
          color: '#FFF',
          formatter: '{value}'
        }
      },
      {
        type: 'value',
        splitLine: {
          show: false
        },
        axisLabel: {
          color: '#FFF',
          formatter: '{value}'
        }
      }
    ],
    series: [
      {
        type: 'line',
        smooth: true,
        data: data1,
        yAxisIndex: 0
      },
      {
        type: 'bar',
        smooth: true,
        data: data2,
        yAxisIndex: 1,
        barWidth: 10
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/config/chart/config_coal_line_ext.js